import { render, staticRenderFns } from "./CabinetSidenav.vue?vue&type=template&id=1e43983b&scoped=true&"
import script from "./CabinetSidenav.vue?vue&type=script&lang=js&"
export * from "./CabinetSidenav.vue?vue&type=script&lang=js&"
import style0 from "./CabinetSidenav.vue?vue&type=style&index=0&id=1e43983b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e43983b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e43983b')) {
      api.createRecord('1e43983b', component.options)
    } else {
      api.reload('1e43983b', component.options)
    }
    module.hot.accept("./CabinetSidenav.vue?vue&type=template&id=1e43983b&scoped=true&", function () {
      api.rerender('1e43983b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/CabinetSidenav.vue"
export default component.exports